export default {"src":"/_next/static/media/linkedinIcon.8de69f09.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};